<script setup lang="ts">
  import { MpBox, MpIcon, MpText, MpUploadSurface, useMpScreen } from '@borg/ui';

  defineProps<{ hasError?: boolean; test?: string; class?: string }>();

  defineEmits<{
    change: [fileList: FileList];
  }>();

  const { isMobile } = useMpScreen();
</script>

<template>
  <MpUploadSurface
    multiple
    :test="test"
    :class="class"
    @change="$emit('change', $event)"
  >
    <template #default="{ isDragOver, open }">
      <MpBox
        ripple
        :class="{
          'upload-surface': true,
          'upload-surface--over': isDragOver,
          'upload-surface--error': hasError,
        }"
        @click="open"
      >
        <MpIcon
          class="upload-surface__icon"
          icon="upload"
        />
        <div class="upload-surface__text-container">
          <div>
            <MpText
              class="upload-surface__text-container__text-primary"
              no-margin
            >
              {{ $t('JOB_APPLICATION_PAGE.UPLOAD_SURFACE_LABEL.1') }}
            </MpText>
            <MpText
              v-if="!isMobile"
              class="upload-surface__text_secondary"
              no-margin
            >
              &nbsp;{{ $t('JOB_APPLICATION_PAGE.UPLOAD_SURFACE_LABEL.2') }}
            </MpText>
          </div>
          <MpText class="upload-surface__text-container__text-notice">
            {{
              $t('JOB_APPLICATION_PAGE.UPLOAD_SURFACE_NOTICE', {
                maxSize: DEFAULT_MAX_FILE_SIZ_IN_MB,
                formats: ACCEPTED_FILE_EXTENSIONS.join(', ').toUpperCase(),
              })
            }}
          </MpText>
        </div>
      </MpBox>
    </template>
  </MpUploadSurface>
</template>

<style scoped lang="scss">
  .upload-surface {
    display: flex;
    align-items: center;
    padding: var(--mp-space-50);
    height: 6rem;
    border: 2px dashed var(--mp-color-border-c-10);
    border-radius: 0.5em;
    background-color: var(--mp-color-surface-10);
    user-select: none;
    cursor: pointer;
    transition: 0.5s;

    &:hover {
      background-color: var(--mp-color-neutral-light);
    }

    &__icon {
      color: var(--mp-color-primary-dark);

      @include dark-mode {
        color: var(--mp-color-primary-light);
      }
    }

    &__text-container {
      margin-left: var(--mp-space-50);

      &__text-primary {
        color: var(--mp-color-primary-dark);
        @include dark-mode {
          color: var(--mp-color-primary-light);
        }
        text-decoration: underline;
      }

      &__text-notice {
        color: var(--mp-color-text-20);
        font-size: 14px;
      }
    }

    &--over {
      outline-color: var(--mp-color-secondary-default);
      transition: outline 100ms ease-in;
    }

    &--error {
      border-color: var(--mp-color-status-error);
    }
  }
</style>
